import { combineReducers } from "redux"
import userProfile from './userProfile'
import userToken from './userToken'

export default combineReducers({ userProfile, userToken })
